Controller = App.loadClass 'core::Angular/Controller'

class exports.DefaultController extends Controller
    constructor: ($scope, $state, $window, $stateParams, Session, Routing) ->
        # We are not authenticated. Route to the welcome site, unless we don't have one
        if not Session.get 'Authorization'
            $state.go 'login', $stateParams
        else
            # console.log 'default controller is asking the routing service to take us somewhere nice'
            Routing.determineDestination($stateParams)
